/* eslint-disable eqeqeq */
import { useEffect, useState } from "react";
import axios from "../../axios";
import { useNavigate, useParams } from "react-router-dom";
import urls from "../../Utils/urls";
import AttachmentsTab from "./AttachmentsTab";
import MyLoanInvestmentTab from "./MyLoanInvestmentTab";
import PropertyInfoTab from "./PropertyInfoTab";
import ReservesTab from "./ReservesTab";
import ImpoundsTab from "./ImpoundsTab";
import LoanTermTab from "./LoanTermTab";
import {
  BlurWrapper,
  BlurWrapperWithSpan,
  extractLenderAccountValue,
  LiButton,
  SpinnerBlock,
} from "../../Utils/CustomComponent";
import { useSelector } from "react-redux";
import PaymentActivityTable from "../../components/AllTables/PaymentActivityTable";
import PastPaymentsToLenderTable from "../../components/AllTables/PastPaymentsToLenderTable";
import LoanCharges from "./LoanCharges";
import ReservesLoanDetailsTable from "../../components/AllTables/ReservesLoanDetailsTable";
import ImpoundsLoanDetailsTable from "../../components/AllTables/ImpoundsLoanDetailsTable";
import { useAbortController } from "../../hooks/useAbortController";
import CommonGrid from "../../components/CommonGrid";
import {
  gridColumns_conversationLog,
  gridColumns_loanFunding,
  gridColumns_notes,
} from "../../Utils/TableColumnDefs";
import classes from "./loandetails.module.css";
import ACHInfoTab from "./ACHInfoTab";

const LoanDetailsComp = ({
  isABorrower = false,
  borrowerLoanId,
  comingFromInsuranceTab = false,
}) => {
  const navigate = useNavigate();
  const [loanDetails, setLoanDetails] = useState(null);
  const [loanTerms, setLoanTerms] = useState(null);
  const [InsuranceInfo, setInsuranceInfo] = useState(null);
  const [loanFunding, setLoanFunding] = useState(null);
  const [notes, setNotes] = useState(null);
  const [conversation, setConversation] = useState(null);
  const [achInfo, setAchInfo] = useState(null);
  const accountId = useSelector((state) => state.account.lenderId);
  let { loanId: loanIdFromParam, selectedtab } = useParams();
  const { signal } = useAbortController();

  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  // const loanId = isABorrower ? borrowerLoanId : loanIdFromParam;
  const loanId = isABorrower ? accountId : loanIdFromParam;

  // const shouldExcludeLoanChargesTab = selectedRole.label.includes("ROC");
  useEffect(() => {
    axios
      .get(urls.dashboard.getLoanTerm1(loanId, accountId), { signal })
      .then((res) => {
        for (const [key, value] of Object.entries(res?.data?.[0]?.[0])) {
          if (value === "") {
            res.data[0][0][key] = "-";
          }
        }
        setLoanTerms(res.data[0][0]);
      });
    function getLoanTerms2() {
      try {
        axios
          .get(urls.dashboard.getLoanTerm2(loanId, accountId), { signal })
          .then((res) => {
            if (res?.data?.[0]?.[0]) {
              for (const [key, value] of Object.entries(res?.data?.[0]?.[0])) {
                if (value === "") {
                  res.data[0][0][key] = "-";
                }
              }
              setLoanDetails(res.data[0][0]);
            }
          });
      } catch (error) {
        console.error(error);
        setLoanDetails([]);
      }
    }

    getLoanTerms2();

    axios
      .get(urls.dashboard.getInsuranceInfo(loanId), { signal })
      .then((res) => {
        setInsuranceInfo(res.data[0]);
      });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loanId]);

  useEffect(() => {
    setLoanFunding(null);
    const fetchLoanFundingData = async () => {
      const res = await axios.get(urls.borrower.getLoanFunding(loanId));
      let data = res?.data?.[0] || [];
      setLoanFunding(
        data.map((innerData) => ({
          ...innerData,
          lender_account: extractLenderAccountValue(innerData.lender_account),
        }))
      );
    };
    fetchLoanFundingData();
  }, [accountId]);

  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
    },
  };

  useEffect(() => {
    setNotes(null);
    async function fetchNotes() {
      try {
        const res = await axios.get(urls.borrower.notes(loanId), headers);
        const data = res?.data?.items || [];
        setNotes(data);
      } catch (error) {
        console.error(error);
      }
    }

    if (!isABorrower) {
      fetchNotes();
    }
  }, [accountId, loanId, isABorrower]);

  useEffect(() => {
    setConversation(null);
    async function fetchConversationLogs() {
      try {
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
            "x-api-key":
              "12kXk3Xiou6Z50k0HSFZ5D8CScq2w6xJThdasldkfjaltht33223Dktkslsk",
          },
        };

        // const res = await axios.get(
        //   urls.borrower.conversationLog(loanId),
        //   headers
        // );
        const res = await axios.post(
          urls.borrower.conversationLog,
          {
            LoanRecId: loanId,
          },
          headers
        );

        // const data = res?.data?.items || [];
        const data =
          res?.data?.[0]?.map((el) => ({
            ...el,
            ["CallType"]: el.CallType == 0 ? "Incoming" : "Outgoing",
          })) || [];

        const sortedData = data.sort(
          // (a, b) => new Date(b.calldate) - new Date(a.calldate)
          (a, b) => new Date(b.CallDate) - new Date(a.CallDate)
        );
        setConversation(sortedData);
      } catch (error) {
        console.error(error);
      }
    }

    if (!isABorrower) {
      fetchConversationLogs();
    }
  }, [accountId, loanId, isABorrower]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          urls.borrower.getPaymentsLoanAchInfo(loanId),
          { signal }
        );
        let data = res.data[0][0];

        setAchInfo(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [loanId]);

  const [activeTab, setActiveTab] = useState(Number(selectedtab) || 0);

  let tabButtons = !isABorrower
    ? [
        {
          label: "My Loan Investment",
        },

        {
          label: "Property Info",
        },
        {
          label: "Attachments",
        },
        {
          label: "Reserves",
        },
        {
          label: "Impounds",
        },
        {
          label: "Loan Terms",
        },
        {
          label: "Loan Charges",
        },
        {
          label: "Recurring ACH Status",
        },
        {
          label: "Conversation Log",
        },
      ]
    : [
        {
          label: "My Loan Information",
        },

        {
          label: "Property Info",
        },
        {
          label: "Attachments",
        },
        {
          label: "Reserves",
        },
        {
          label: "Impounds",
        },
        {
          label: "Loan Terms",
        },
        {
          label: "Loan Charges",
        },
      ];
  // if (shouldExcludeLoanChargesTab) {
  //   tabButtons = tabButtons.filter((tab) => tab.label !== "Loan Charges");
  // }
  if (selectedRole === "V" && selectedAccount?.databasename !== "ROC") {
    tabButtons = [
      ...tabButtons,
      {
        label: "Loan Funding",
      },
    ];
  }

  // if (selectedRole === "L") {
  //   tabButtons = tabButtons.map((item) =>
  //     item.label === "Notes" ? { label: "Recurring ACH Status" } : item
  //   );
  // }

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        {!isABorrower ? (
          <article className="container-fluid">
            <div className="p-3 pb-0  mt-1">
              <h6>
                <span
                  className="linkClick"
                  role="button"
                  onClick={() => navigate(-1)}
                >
                  Back
                </span>{" "}
                / Loan details -{" "}
                <BlurWrapperWithSpan>
                  {loanDetails?.["account"]}
                </BlurWrapperWithSpan>
              </h6>
            </div>
          </article>
        ) : comingFromInsuranceTab ? (
          <article className="container-fluid">
            <div className="p-3 pb-0  mt-1">
              <h6>
                <span
                  className="linkClick"
                  role="button"
                  onClick={() => navigate("/borrower-dashboard-two")}
                >
                  Dashboard
                </span>{" "}
                <span
                  className="linkClick"
                  role="button"
                  onClick={() => navigate("/loans")}
                >
                  / Loans
                </span>{" "}
                / Loan details -{" "}
                <BlurWrapperWithSpan>
                  {loanDetails?.["account"]}
                </BlurWrapperWithSpan>
              </h6>
            </div>
          </article>
        ) : null}
        <article className={isABorrower ? "" : "container-fluid"}>
          {loanDetails ? (
            <section className={`bg-white p-5 ${!isABorrower && "my-2 mx-4"}`}>
              <div className="row"></div>
              {/* property details */}
              <h4 className="mt-5">Loan Details</h4>
              <div className="loan-details">
                <div
                  className={`row w-100 p-5 m-0 ${
                    loanDetails?.statuses.includes(",") ? "bg-yellow" : ""
                  }`}
                  style={{
                    border: "1px solid rgba(0,0,0,0.1)",
                    borderRadius: "0px",
                  }}
                >
                  <DataBlock
                    className={"col-3"}
                    label={"Investment Amount"}
                    value={loanDetails?.["loan_amount"]}
                  />
                  <DataBlock
                    className={"col-3"}
                    label={"Loan No."}
                    value={loanDetails?.["account"]}
                  />
                  <DataBlock
                    className={"col"}
                    label={"Property Address"}
                    value={
                      extractContent(loanDetails?.loanheader).split(":")[2]
                    }
                  />
                </div>
                <div className="pt-5 mt-5">
                  <ul className="nav nav-tabs">
                    {tabButtons?.map((data, index) => (
                      <LiButton
                        key={index}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        label={data.label}
                        value={index}
                      />
                    ))}
                  </ul>
                </div>
              </div>
              {loanDetails?.statuses.includes(",") && (
                <div className="mb-5 alert alert-yellow bg-yellow d-flex gap-5">
                  {loanDetails?.statuses
                    .split(",")
                    .filter((item) => item !== "")
                    .map((item) => (
                      <div className="px-5 rounded-pill border-1 border bg-grey">
                        <strong className="">{item}</strong>
                      </div>
                    ))}
                </div>
              )}
              <div className="loans-in-details mt-5">
                {activeTab == 0 ? (
                  <MyLoanInvestmentTab
                    loanDetails={loanDetails}
                    loanTerms={loanTerms}
                    account_id={loanDetails?.["account"]}
                    selectedRole={selectedRole}
                    isABorrower={isABorrower}
                  />
                ) : null}

                {activeTab == 1 ? (
                  <PropertyInfoTab
                    insuranceInfo={InsuranceInfo}
                    isABorrower={isABorrower}
                  />
                ) : null}
                {activeTab == 2 ? (
                  <AttachmentsTab
                    loanID={loanId}
                    showUploadMore={false}
                    loandetailsView={true}
                  />
                ) : null}

                {activeTab == 3 ? (
                  <ReservesTab loanDetails={loanDetails} loanId={loanId} />
                ) : null}
                {activeTab == 4 ? (
                  <ImpoundsTab loanDetails={loanDetails} loanId={loanId} />
                ) : null}
                {activeTab == 5 ? (
                  <LoanTermTab
                    loanDetails={loanDetails}
                    loanTerms={loanTerms}
                  />
                ) : null}
                {/* {activeTab == 6 && !shouldExcludeLoanChargesTab ? (
                  <LoanCharges loanId={loanId} />
                ) : null} */}
                {activeTab == 6 ? <LoanCharges loanId={loanId} /> : null}

                {tabButtons?.[activeTab].label === "Recurring ACH Status" && (
                  <ACHInfoTab achData={achInfo} />
                )}
              </div>
            </section>
          ) : null}
          <div
            className="row mt-5 px-4"
            style={{ background: "rgb(238, 238, 238)" }}
          >
            {activeTab === 3 && <ReservesLoanDetailsTable loanId={loanId} />}
            {activeTab === 4 && <ImpoundsLoanDetailsTable loanId={loanId} />}
            {/* <TrustLedgerReserveTable className={"col-lg-6"} /> */}
            {/* <EventJournalTable className={"col-lg-6"} /> */}
            {(activeTab <= 6 ||
              tabButtons?.[activeTab].label === "Recurring ACH Status") && (
              <>
                <PaymentActivityTable loanId={loanId} className={"col-lg-12"} />
                {!isABorrower ? (
                  <PastPaymentsToLenderTable
                    loanId={loanId}
                    className={"col-lg-12"}
                  />
                ) : null}
              </>
            )}

            {tabButtons?.[activeTab].label === "Loan Funding" &&
            ((selectedRole === "V" &&
              selectedAccount?.databasename !== "ROC") ||
              isABorrower) ? (
              <div>
                {loanFunding ? (
                  <CommonGrid
                    isDashboard={true}
                    className={"col-sm-12"}
                    title={"Loan Funding"}
                    gridColumns={gridColumns_loanFunding}
                    columnData={loanFunding}
                  />
                ) : (
                  <SpinnerBlock />
                )}
              </div>
            ) : null}
            {tabButtons?.[activeTab].label === "Notes" && !isABorrower && (
              <div>
                {notes ? (
                  <CommonGrid
                    isDashboard={true}
                    className={"col-sm-12"}
                    title={"Notes"}
                    gridColumns={gridColumns_notes}
                    columnData={notes}
                  />
                ) : (
                  <SpinnerBlock />
                )}
              </div>
            )}

            {tabButtons?.[activeTab].label === "Conversation Log" &&
              !isABorrower && (
                <div>
                  {conversation ? (
                    <div>
                      <div style={{ overflowY: "scroll" }}>
                        <CommonGrid
                          isDashboard={true}
                          className={`col-sm-12`}
                          title={"Conversation Log"}
                          gridColumns={gridColumns_conversationLog}
                          columnData={conversation}
                          isDifferent={true}
                        />
                      </div>
                    </div>
                  ) : (
                    <SpinnerBlock />
                  )}
                </div>
              )}
          </div>
        </article>
      </section>
    </div>
  );
};
export default LoanDetailsComp;

const extractContent = (s) => {
  var span = document.createElement("span");
  span.innerHTML = s;
  return span.textContent || span.innerText;
};

const DataBlock = ({ className, label, value }) => {
  return (
    <div className={className}>
      <span style={{ color: "grey" }}>{label}</span>
      <BlurWrapper>
        <p>{value}</p>
      </BlurWrapper>
    </div>
  );
};
